import { HistoryFiltersConfig } from '../../configuration'

/**
 * Array of attribute names to display in the Attributes filter for Volleyball.
 * These names will be matched dynamically against incident attributes from the sport API data.
 */
export const historyFiltersAttributesConfig: HistoryFiltersConfig['historyFiltersAttributes'] =
  [
    'Spectacular',
    'Free ball',
    'Perfect',
    'Plus',
    'Negative',
    'Error',
    'Blocked back',
    'Zone 1',
    'Zone 2',
    'Zone 3',
    'Zone 4',
    'Zone 5',
    'Zone 6',
    'Out attack',
    'Antenna attack',
    'Net attack',
    'Illegal touch',
    'Rotation error',
    'Foot fault',
    'Net touch',
    'Yellow card',
    'Red card',
    'Player expulsion',
    'Player disqualification',
    'Challenge correct',
    'Challenge incorrect',
    'Call stands',
    'Call overturned',
  ]
